import {
  formatValue,
  getStatisticUnitTitle,
  getUserDefinedUnitVal,
  wellnessListModel,
} from '@/Components/Wellness/WellnessUtils';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { useSelector } from 'react-redux';
import { formatTimestamp } from '../Dashboard/Home/RecentActivity/RecentActivityUtils';
import { useApiQuery } from './useApiQuery';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

function processRawData({ data, timezone, measurementSystem, locale, is24HourFormat, trans }) {
  const processedData = [];
  if (!data || Object.keys(data).length === 0) {
    return processedData;
  }

  if (!wellnessListModel || !wellnessListModel['medical_accessories']) {
    console.error('wellnessListModel or medical_accessories is null or undefined.');
    return processedData;
  }
  const wellnessModel = JSON.parse(JSON.stringify(wellnessListModel));
  const allowedKeys = [];

  Object.keys(data).forEach((key) => {
    const entry = data[key][0];
    allowedKeys.push(key);

    if (!entry) {
      //console.warn(`No entry found for key: ${key}`);
      return;
    }

    let dateTimeObj = formatTimestamp(
      entry.utc_timestamp_inms,
      timezone,
      locale,
      is24HourFormat,
      trans
    );
    let day = dateTimeObj['day'];
    let time = dateTimeObj['time'];
    let timeDifference = dateTimeObj['difference'];
    let formattedDate = dateTimeObj['formattedDate'];

    if (!wellnessModel['medical_accessories'][key]) {
      console.warn(`No medical_accessories data for key: ${key}`);
      wellnessModel['medical_accessories'][key] = {};
    }

    const statisticDataArray = Object.keys(wellnessModel['medical_accessories'][key]['data'] || []);
    const FinalStatisticDataArray = statisticDataArray.map((item) => {
      const newObj = {};
      const getUserDefinedMeasurementValue = entry?.devicetypeid
        ? getUserDefinedUnitVal(entry?.data?.[item], entry?.devicetypeid, measurementSystem)
        : '-';
      newObj['display_label'] = getStatisticUnitTitle(String(item), measurementSystem);
      newObj['display_value'] = `${formatValue(getUserDefinedMeasurementValue)}${
        +entry?.data?.[item]?.unit != undefined && entry?.data?.[item]?.unit === 'F' ? '°' : ''
      }`;
      return newObj;
    });
    wellnessModel['medical_accessories'][key]['title'] = key;
    wellnessModel['medical_accessories'][key]['day'] = day;
    wellnessModel['medical_accessories'][key]['time'] = time;
    wellnessModel['medical_accessories'][key]['timeDiff'] = timeDifference;
    wellnessModel['medical_accessories'][key]['formattedDate'] = formattedDate;
    wellnessModel['medical_accessories'][key]['utc_timestamp_inms'] = entry['utc_timestamp_inms'];
    wellnessModel['medical_accessories'][key]['data'] = FinalStatisticDataArray;
    wellnessModel['medical_accessories'][key]['deviceManufacture'] = entry.device_manufacturer;
    wellnessModel['medical_accessories'][key]['deviceModel'] = entry.device_model;
    wellnessModel['medical_accessories'][key]['device_uuid'] = entry.deviceuuid;
    wellnessModel['medical_accessories'][key]['eventName'] = entry.eventname;
  });
  const mappedData = JSON.parse(JSON.stringify(wellnessModel));
  const medicalAccessories = mappedData.medical_accessories;
  Object.keys(medicalAccessories).forEach((key) => {
    if (!allowedKeys.includes(key)) {
      delete medicalAccessories[key];
    }
  });
  return mappedData;
}

const useGetUserMedicalAccessories = (props) => {
  const { useruuid, enabled = true } = props;
  const trans = useSelector(translator);
  const userEventsApi = useSelector((state) => state.apis.userEventsApi);

  return useApiQuery(
    ['getUserMedicalAccessories', useruuid],
    () =>
      new Promise((resolve, reject) => {
        try {
          userEventsApi.getUserMedicalAccessories(
            useruuid,
            {},
            apiCallback({
              translator: trans,
              successCallback: (data) => {
                const processedData = processRawData({
                  ...props,
                  data: data?.user_accessories,
                  trans,
                });
                resolve(processedData);
              },
              errorCallback: (errors) => {
                console.error('Error fetching wellness api information:', errors);
                reject(errors);
              },
              failCallback: (errors) => {
                console.error('Error fetching wellness api information:', errors);
                reject(errors);
              },
            })
          );
        } catch (error) {
          console.error('Error fetching wellness api information:', error);
          reject(error);
        }
      }),
    { enabled: !!useruuid && enabled }
  );
};

export default useGetUserMedicalAccessories;
